// this data is used to contruct analytics data layer
import { Injectable } from '@angular/core';
import { OfferSettingService } from '@features/offer/services';
import {
  OfferCategoryOption,
  OfferChannelOption,
  OfferCityOption,
  OfferSortOption,
} from '@rd/types';

export const categoryOptions: OfferCategoryOption[] = [
  { name: 'offer.filter_modal.category.all', value: '' },
  { name: 'offer.filter_modal.category.dining', value: 'dining' },
  { name: 'offer.filter_modal.category.shopping', value: 'shopping' },
  { name: 'offer.filter_modal.category.lifestyle', value: 'lifestyle' },
  { name: 'offer.filter_modal.category.others', value: 'others' },
];

export const channelOptions: OfferChannelOption[] = [
  { name: 'offer.filter_modal.channel.all', value: '' },
  { name: 'offer.filter_modal.channel.online', value: 'online' },
  { name: 'offer.filter_modal.channel.in_store', value: 'offline' },
  { name: 'offer.filter_modal.channel.phone', value: 'phone' },
];

export const sortOptions: OfferSortOption[] = [
  { name: 'offer.sort_modal.recommended', value: '-score_by_recommended' },
  { name: 'offer.sort_modal.nearby', value: '-score_by_distance' },
  { name: 'offer.sort_modal.recently_added', value: '-created_at' },
  { name: 'offer.sort_modal.a_z', value: 'brand' },
  { name: 'offer.sort_modal.z_a', value: '-brand' },
  { name: 'offer.sort_modal.expiring_soonest', value: 'end_time' },
];

@Injectable()
export class WestpacOfferSettingService extends OfferSettingService {
  categoryOptions = categoryOptions;
  channelOptions = channelOptions;
  cityOptions: OfferCityOption[] = [];
  sortOptions = sortOptions;
  offerImageRatio = '4:2';
  displayLongDescription = true;
}
